var exports = {
  "iE": "xa15a2ab7--099193--wrapper",
  "DD": "xa15a2ab7--099193--title",
  "g_": "xa15a2ab7--099193--proofs",
  "qS": "xa15a2ab7--099193--badge",
};

module.exports = exports;
